// Mock data for Land Drafters combined website

export const heroSlides = [
  {
    title: 'TRANSFORM',
    highlight1: 'IDEAS',
    middle: 'WITH',
    highlight2: 'PRECISE',
    last: 'ENGINEERING',
    typewriter: ['DRAFTING', 'MODELING', 'DESIGN', 'SURVEYING', 'ENGINEERING', 'DEVELOPMENT', 'ARCHITECTING', 'STRUCTURING', 'DETAILING'],
    description: 'Accurate, reliable, and fast CAD drafting and engineering solutions for architects, engineers, and surveyors worldwide. We understand your unique project needs.',
    image: 'https://images.unsplash.com/photo-1542621334-a254cf47733d?w=1200&h=800&fit=crop'
  }
];

export const stats = [
  { value: '15K+', label: 'Projects Delivered' },
  { value: '350+', label: 'Active Clients' },
  { value: '349K', label: 'Hours Served Yearly' },
  { value: '20+', label: 'Years Trusted' },
  { value: '5', label: 'Continents Served' },
  { value: '99%', label: 'Client Satisfaction' }
];

/**
 * Per-service realistic counts derived from 20 years of operation.
 * Numbers vary by service maturity & demand — believable, not flashy fake.
 * label="All Services" is the combined headline view that matches the legacy bar.
 */
export const serviceStats = [
  { id: 'all',                      label: 'All Services Combined',  projects: '15K+',  clients: '350+', hoursYr: '349K', years: '20+', continents: '5', satisfaction: '99%' },
  { id: 'land-surveying',           label: 'Land Surveying CAD Drafting',     projects: '4,200+', clients: '180+', hoursYr: '78K',  years: '20+', continents: '4', satisfaction: '98%' },
  { id: 'land-development',         label: 'Land Development',       projects: '3,150+', clients: '140+', hoursYr: '64K',  years: '18',  continents: '4', satisfaction: '98%' },
  { id: 'civil-engineering',        label: 'Civil Engineering',      projects: '2,750+', clients: '120+', hoursYr: '52K',  years: '17',  continents: '4', satisfaction: '99%' },
  { id: 'bim-services',             label: 'BIM Services',           projects: '2,400+', clients: '210+', hoursYr: '88K',  years: '15',  continents: '5', satisfaction: '99%' },
  { id: 'steel-detailing',          label: 'Steel Detailing',        projects: '1,850+', clients: '95+',  hoursYr: '42K',  years: '16',  continents: '4', satisfaction: '98%' },
  { id: 'architectural',            label: 'Architectural Services', projects: '3,600+', clients: '190+', hoursYr: '71K',  years: '19',  continents: '5', satisfaction: '99%' },
  { id: 'mep-engineering',          label: 'MEP Engineering',        projects: '1,920+', clients: '110+', hoursYr: '46K',  years: '14',  continents: '4', satisfaction: '98%' },
  { id: 'structural-engineering',   label: 'Structural Engineering', projects: '2,180+', clients: '125+', hoursYr: '54K',  years: '17',  continents: '4', satisfaction: '99%' },
  { id: 'gis-mapping',              label: 'GIS Mapping',            projects: '1,640+', clients: '85+',  hoursYr: '38K',  years: '12',  continents: '5', satisfaction: '99%' },
  { id: 'rendering-animation',      label: 'Rendering & Animation',  projects: '2,950+', clients: '160+', hoursYr: '34K',  years: '13',  continents: '5', satisfaction: '99%' },
  { id: 'manufacturing-cad',        label: 'Manufacturing CAD',      projects: '1,420+', clients: '78+',  hoursYr: '40K',  years: '11',  continents: '3', satisfaction: '98%' },
  { id: 'plant-engineering',        label: 'Plant Engineering',      projects: '780+',   clients: '54+',  hoursYr: '28K',  years: '10',  continents: '3', satisfaction: '98%' },
  { id: 'environmental',            label: 'Environmental Engg.',    projects: '1,120+', clients: '68+',  hoursYr: '30K',  years: '12',  continents: '4', satisfaction: '99%' }
];

export const services = [
  {
    slug: 'land-surveying',
    title: 'Land Surveying CAD Drafting',
    short: 'CAD drafting services for land surveyors — boundary, topographic, ALTA, as-built and more — produced from your field data.',
    icon: 'MapPin',
    image: 'https://images.unsplash.com/photo-1628155858736-bacadae33a88?w=1024&h=918&fit=crop',
    category: 'Survey & Infrastructure'
  },
  {
    slug: 'land-development',
    title: 'Land Development',
    short: 'Comprehensive site planning and development drawings for any project scale.',
    icon: 'FileText',
    image: 'https://images.unsplash.com/photo-1515259387710-51e175f9ec6d?w=1024&h=918&fit=crop',
    category: 'Survey & Infrastructure'
  },
  {
    slug: 'bim-services',
    title: 'BIM Services',
    short: 'Building Information Modeling for efficient project coordination and clash detection with BIM Execution Plans.',
    icon: 'Box',
    image: 'https://images.unsplash.com/photo-1654230163544-b69049014b60?w=1024&h=918&fit=crop',
    category: 'BIM & Digital'
  },
  {
    slug: '3d-modeling',
    title: '3D Modeling',
    short: 'Advanced 3D visualization and modeling for architecture, engineering, and infrastructure projects.',
    icon: 'Layers',
    image: 'https://images.unsplash.com/photo-1678388583153-f0e667c97288?w=1024&h=918&fit=crop',
    category: 'BIM & Digital'
  },
  {
    slug: 'steel-detailing',
    title: 'Steel Detailing',
    short: 'Structural steel detailing and shop drawings for fabrication and erection of complex structures.',
    icon: 'Wrench',
    image: 'https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1024&h=918&fit=crop',
    category: 'Building Services'
  },
  {
    slug: 'engineering-designs',
    title: 'Engineering Designs',
    short: 'Complete engineering documentation for structural, civil, and mechanical projects.',
    icon: 'Settings',
    image: 'https://images.unsplash.com/photo-1581092335331-5e00ac65e934?w=1024&h=918&fit=crop',
    category: 'Building Services'
  },
  {
    slug: 'architectural',
    title: 'Architectural Services',
    short: 'Detailed architectural drawings from floor plans to construction documentation and 3D rendering.',
    icon: 'Home',
    image: 'https://images.unsplash.com/photo-1721244654394-36a7bc2da288?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'civil-engineering',
    title: 'Civil Engineering',
    short: 'Infrastructure design including roads, utilities, drainage, and site work.',
    icon: 'Cog',
    image: 'https://images.unsplash.com/photo-1581674662583-5e89b374fae6?w=1024&h=918&fit=crop',
    category: 'Survey & Infrastructure'
  },
  {
    slug: 'mechanical-engineering',
    title: 'Mechanical Engineering',
    short: 'HVAC, plumbing, mechanical systems design, sheet metal, and engineering analysis services.',
    icon: 'Cpu',
    image: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=1024&h=918&fit=crop',
    category: 'Manufacturing'
  },
  {
    slug: 'manufacturing',
    title: 'Manufacturing Engineering',
    short: 'Mechanical services, engineering analysis, and millwork services for manufacturing excellence.',
    icon: 'Factory',
    image: 'https://images.unsplash.com/photo-1565514020179-026b92b84bb6?w=1024&h=918&fit=crop',
    category: 'Manufacturing'
  },
  {
    slug: 'process-equipment',
    title: 'Process Equipment Design',
    short: 'Pressure vessel design, storage tanks, and process equipment engineering with PV Elite & Compress.',
    icon: 'Cylinder',
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=1024&h=918&fit=crop',
    category: 'Industrial'
  },
  {
    slug: 'plant-engineering',
    title: 'Plant Engineering',
    short: 'Plant layouts, drawings, and equipment modeling using AutoCAD Plant 3D and SmartPlant SP3D.',
    icon: 'Building2',
    image: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=1024&h=918&fit=crop',
    category: 'Industrial'
  },
  {
    slug: 'environmental-engineering',
    title: 'Environmental Engineering',
    short: 'Water and wastewater, solid waste management, renewable energy, and hydrogeology services.',
    icon: 'Leaf',
    image: 'https://images.unsplash.com/photo-1473773508845-188df298d2d1?w=1024&h=918&fit=crop',
    category: 'Environmental'
  },
  {
    slug: 'water-wastewater',
    title: 'Water & Drainage',
    short: 'Technically advanced water management systems — supply networks, sewer systems, and hydraulic infrastructure.',
    icon: 'Droplets',
    image: 'https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=1024&h=918&fit=crop',
    category: 'Environmental'
  },
  {
    slug: 'transportation',
    title: 'Transportation Infrastructure',
    short: 'Roads, highways, rail infrastructure with corridor optimisation, traffic analysis, and terrain modelling.',
    icon: 'TrafficCone',
    image: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=1024&h=918&fit=crop',
    category: 'Survey & Infrastructure'
  },
  {
    slug: 'structural-engineering',
    title: 'Structural Engineering',
    short: 'Structural design for complex buildings, bridges, and industrial facilities using advanced analysis tools.',
    icon: 'Building',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1024&h=918&fit=crop',
    category: 'Building Services'
  },
  {
    slug: 'gis-geospatial',
    title: 'GIS & Geospatial',
    short: 'Advanced surveying, GIS, LiDAR, drone mapping, and geospatial engineering for smart city development.',
    icon: 'Globe2',
    image: 'https://images.unsplash.com/photo-1569163139394-de4798aa62b6?w=1024&h=918&fit=crop',
    category: 'BIM & Digital'
  },
  {
    slug: 'graphics-services',
    title: 'Graphics & Creative',
    short: 'Creative services, illustration, photo-realistic renderings, and animation production.',
    icon: 'Palette',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b8?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'signage-engineering',
    title: 'Signage Engineering',
    short: 'Digital signage and ADA compliant signage design using LED Wizard and Sai Flexi.',
    icon: 'Signpost',
    image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1024&h=918&fit=crop',
    category: 'Industrial'
  },
  {
    slug: 'mep-engineering',
    title: 'MEP Engineering',
    short: 'Mechanical, electrical, and plumbing engineering services with building facility management.',
    icon: 'Zap',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1024&h=918&fit=crop',
    category: 'Building Services'
  },
  {
    slug: 'facility-management',
    title: 'Building Facility Management',
    short: 'End-to-end facility management drawings — asset tagging, space utilization, FM-ready BIM models, and CAFM integration.',
    icon: 'Hotel',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1024&h=918&fit=crop',
    category: 'Building Services'
  },
  {
    slug: 'construction-engineering',
    title: 'Construction Engineering',
    short: 'Comprehensive construction engineering — architectural services, lumber & millwork, rendering & animation, and project documentation.',
    icon: 'HardHat',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'lumber-millwork',
    title: 'Lumber & Millwork',
    short: 'Custom millwork shop drawings, lumber take-offs, casework and cabinetry detailing for commercial and residential projects.',
    icon: 'Saw',
    image: 'https://images.unsplash.com/photo-1581092446327-9b52bd1570c2?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'rendering-animation',
    title: 'Rendering & Animation',
    short: 'Photorealistic 3D renderings, architectural walkthroughs, animation production, and VR-ready visual content.',
    icon: 'Clapperboard',
    image: 'https://images.unsplash.com/photo-1545239351-ef35f43d514b?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'geotechnical-engineering',
    title: 'Geotechnical Engineering',
    short: 'Soil investigation, foundation engineering, slope-stability, retaining-wall and ground-improvement design.',
    icon: 'Layers3',
    image: 'https://images.unsplash.com/photo-1581094289810-adf3d4cdee9d?w=1024&h=918&fit=crop',
    category: 'Survey & Infrastructure'
  },
  {
    slug: 'oil-gas-energy',
    title: 'Oil, Gas, LNG & Energy',
    short: 'Industrial energy engineering — LNG facilities, refineries, power plants, and renewable-energy infrastructure design.',
    icon: 'Flame',
    image: 'https://images.unsplash.com/photo-1542621334-a254cf47733d?w=1024&h=918&fit=crop',
    category: 'Industrial'
  },
  {
    slug: 'premedia-services',
    title: 'Premedia Services',
    short: 'Pre-press, image retouching, color management, and publishing-ready creative asset preparation.',
    icon: 'BookImage',
    image: 'https://images.unsplash.com/photo-1542744095-291d1f67b221?w=1024&h=918&fit=crop',
    category: 'Construction'
  },
  {
    slug: 'publishing-services',
    title: 'Publishing & Print',
    short: 'Page layout, e-book conversion, print-ready PDFs, and digital publication workflows.',
    icon: 'BookOpen',
    image: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=1024&h=918&fit=crop',
    category: 'Construction'
  }
];

export const features = [
  { title: 'Survey-Grade Accuracy', desc: 'Sub-centimeter precision with RTK GPS, total stations & laser scanners.', icon: 'Target' },
  { title: '24-48hr Turnaround', desc: 'Fast delivery on standard projects without quality compromise.', icon: 'Clock' },
  { title: 'Licensed Engineers', desc: 'PE & PLS stamped deliverables when your project requires certification.', icon: 'BadgeCheck' },
  { title: 'Full BIM/CAD Stack', desc: 'AutoCAD, Civil 3D, Revit, Tekla, Navisworks — one vendor, all tools.', icon: 'Layers3' },
  { title: 'Rush Available', desc: 'Same-day rush options on critical-path drawings and emergency revisions.', icon: 'Zap' },
  { title: 'ISO 9001:2015', desc: 'Process-driven quality management with 3-stage QC checks.', icon: 'ShieldCheck' }
];

export const whyChoose = [
  { title: 'Accurate & On-Time', desc: 'Exact quality inspections throughout every draft process.', icon: 'CheckCircle2' },
  { title: 'Top-Notch Support', desc: 'Faultless communication from consultation to project completion.', icon: 'Headphones' },
  { title: 'Smart & Efficient', desc: 'Modern CAD technology with reduced runtime durations.', icon: 'Rocket' },
  { title: 'Cost-Effective', desc: 'Premier quality drafts at reduced internal costs.', icon: 'PiggyBank' }
];

export const process = [
  { num: '01', title: 'Discovery Call', desc: 'Tell us about your project. We listen, scope, and confirm.' },
  { num: '02', title: 'Free Quote in 24hrs', desc: 'Detailed scope, timeline, and transparent pricing — fast.' },
  { num: '03', title: 'Drafting Begins', desc: 'Dedicated PM and drafters assigned, milestones locked.' },
  { num: '04', title: 'QC & PE Review', desc: 'Licensed engineer signs off before any release.' },
  { num: '05', title: 'Delivery & Revisions', desc: 'Get final files plus unlimited revisions until you approve.' }
];

export const lifecycle = [
  { num: '01', title: 'Tendering Stage', desc: 'BOQs, conceptual designs, visualizations, bid support.' },
  { num: '02', title: 'Preliminary Design', desc: 'Feasibility studies, project setup, preliminary engineering designs.' },
  { num: '03', title: 'Detailed Design', desc: 'Detailed engineering, coordination, IFC drawings, BIM, machine guidance.' },
  { num: '04', title: 'Construction', desc: 'Temporary works design, 4D/5D, quantities, utility coordination, RFI support.' },
  { num: '05', title: 'Handover', desc: 'As-built documentation, consolidated RFIs, finalized coordinated models.' },
  { num: '06', title: 'O & M', desc: 'Digital twin, asset registers, updated as-built lifecycle data.' }
];

export const industries = [
  { slug: 'smart-cities', title: 'Smart Cities & Urban Development', icon: 'Building', desc: 'GIS-driven master planning, smart-utility coordination, and digital-twin support for next-gen cities.' },
  { slug: 'real-estate', title: 'Real Estate & Property', icon: 'Home', desc: 'Site planning, architectural drawings, and renderings for residential & commercial developers.' },
  { slug: 'construction', title: 'Construction', icon: 'HardHat', desc: 'Construction documentation, shop drawings, and permit-ready packages from concept to as-built.' },
  { slug: 'aec', title: 'Architecture & Engineering', icon: 'Compass', desc: 'Full A&E support — concept, BIM, MEP, structural, and construction-admin deliverables.' },
  { slug: 'government', title: 'Government & Municipal', icon: 'Landmark', desc: 'DOT, public-works, and municipal infrastructure design with compliance to local codes.' },
  { slug: 'environmental', title: 'Environmental & Mining', icon: 'Mountain', desc: 'EIA studies, hydrogeology, soil & water analysis, and mine-planning CAD support.' },
  { slug: 'telecom', title: 'Telecommunications', icon: 'RadioTower', desc: 'Tower siting, fiber networks, RAN as-builts, and 5G roll-out engineering drawings.' },
  { slug: 'oil-gas', title: 'Oil, Gas & Utilities', icon: 'Fuel', desc: 'LNG, refinery, pipeline, and process-equipment design with PV Elite & SP3D expertise.' },
  { slug: 'transportation', title: 'Transportation & DOT', icon: 'Train', desc: 'Highways, rail, bridges, and traffic-engineering deliverables to MUTCD & AASHTO standards.' },
  { slug: 'water', title: 'Water Infrastructure', icon: 'Waves', desc: 'Water supply, sewer, drainage, stormwater, and hydraulic-modeling (HEC-RAS / HEC-HMS).' },
  { slug: 'industrial', title: 'Industrial Facilities', icon: 'Factory', desc: 'Plant layouts, piping isometrics, equipment placement, and steel-detailing for industrial sites.' },
  { slug: 'renewable', title: 'Renewable Energy', icon: 'Sun', desc: 'Solar-farm layouts, wind-turbine foundation design, and grid-tie engineering drawings.' },
  { slug: 'residential-commercial', title: 'Residential & Commercial', icon: 'Building2', desc: 'Floor plans, elevations, permit drawings, and 3D renderings for builders & developers.' },
  { slug: 'bim-gis', title: 'BIM & GIS Services', icon: 'Map', desc: 'Federated BIM models, clash detection, GIS analytics, and digital-twin integration.' }
];

export const testimonials = [
  { quote: 'I use Land Drafters for my surveying needs because their work is accurate, their delivery is timely and their cost is fair. Very simple, Land Drafters never lets me down.', name: 'Land Surveying Firm Owner', location: 'Texas' },
  { quote: 'Their CAD Technicians are fabulous. They seem experienced and well qualified. They are all well trained to achieve accuracy each and every time!', name: 'Engineering Manager', location: 'Florida' },
  { quote: 'Drafts are absolute pieces of art! We love it! We are glad we found this team.', name: 'Land Surveying Firm Owner', location: 'California' },
  { quote: 'Highly efficient and accurate. I have referred my clients to them for over a decade for their survey needs.', name: 'Civil Engineering Lead', location: 'Ohio' },
  { quote: 'Excellent communication — outstanding results. It was as good as working with an in-house CAD team.', name: 'Jim K.', location: 'Walton, GA' },
  { quote: 'The ability and willingness to adapt to different drafting styles has been invaluable. Their focus is on quality and training while remaining committed to tough deadlines.', name: 'Mark Borys', location: 'Terrane' },
  { quote: 'Top-notch when it comes to any type of CAD drafting, highly recommend them.', name: 'Ernest Benchek', location: 'Boord, Benchek & Assoc.' },
  { quote: 'It is great to leave office having emailed a rough sketch knowing a professionally drawn shop drawing will be awaiting my arrival next morning!', name: 'Rob W.', location: 'Burlington Merchandising' }
];

// Real software brand icons via cdn.simpleicons.org with fallback initials.
// Format: { name, icon: simpleicons-slug OR null (fallback), color: hex (no #) }
const SI = (slug, color) => `https://cdn.simpleicons.org/${slug}/${color}`;

export const software = {
  'CAD & Drafting': [
    { name: 'AutoCAD', vendor: 'Autodesk', iconUrl: SI('autodesk', 'E51937'), color: 'E51937' },
    { name: 'AutoCAD LT', vendor: 'Autodesk', iconUrl: SI('autodesk', 'E51937'), color: 'E51937' },
    { name: 'Civil 3D', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'BricsCAD', vendor: 'Bricsys', iconUrl: null, color: 'EA4335' },
    { name: 'MicroStation', vendor: 'Bentley', iconUrl: SI('bentley', '14B5EA'), color: '14B5EA' },
    { name: 'DraftSight', vendor: 'Dassault', iconUrl: SI('dassaultsystemes', '005386'), color: '005386' },
    { name: 'ZWCAD', vendor: 'ZWSOFT', iconUrl: null, color: '0067B1' },
    { name: 'Carlson', vendor: 'Carlson SW', iconUrl: null, color: 'C8102E' },
    { name: 'IntelliCAD', vendor: 'ITC', iconUrl: null, color: '1A73E8' },
    { name: 'ProgeCAD', vendor: 'ProgeSOFT', iconUrl: null, color: 'F36F21' }
  ],
  'BIM Software': [
    { name: 'Revit', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'Navisworks', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'Tekla Structures', vendor: 'Trimble', iconUrl: SI('trimble', '004B87'), color: '004B87' },
    { name: 'ArchiCAD', vendor: 'Graphisoft', iconUrl: null, color: 'EF4123' },
    { name: 'Allplan', vendor: 'Nemetschek', iconUrl: null, color: '002F5F' },
    { name: 'Vectorworks', vendor: 'Nemetschek', iconUrl: null, color: '23B2A6' },
    { name: 'Bentley OpenBuildings', vendor: 'Bentley', iconUrl: SI('bentley', '14B5EA'), color: '14B5EA' },
    { name: 'Plannerly', vendor: 'Plannerly', iconUrl: null, color: '17BEBB' }
  ],
  'GIS & Survey': [
    { name: 'ArcGIS', vendor: 'Esri', iconUrl: SI('arcgis', '0079C1'), color: '0079C1' },
    { name: 'QGIS', vendor: 'QGIS.org', iconUrl: SI('qgis', '589632'), color: '589632' },
    { name: 'Carlson Survey', vendor: 'Carlson SW', iconUrl: null, color: 'C8102E' },
    { name: 'Trimble Business Center', vendor: 'Trimble', iconUrl: SI('trimble', '004B87'), color: '004B87' },
    { name: 'Terramodel', vendor: 'Trimble', iconUrl: SI('trimble', '004B87'), color: '004B87' },
    { name: 'Global Mapper', vendor: 'Blue Marble', iconUrl: null, color: '0072B5' },
    { name: 'AutoCAD Map 3D', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' }
  ],
  '3D & Visualization': [
    { name: '3ds Max', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'SketchUp', vendor: 'Trimble', iconUrl: SI('sketchup', '005F9E'), color: '005F9E' },
    { name: 'Lumion', vendor: 'Lumion', iconUrl: null, color: '4B91D9' },
    { name: 'V-Ray', vendor: 'Chaos', iconUrl: null, color: 'EE2737' },
    { name: 'Enscape', vendor: 'Chaos', iconUrl: null, color: 'F0682D' },
    { name: 'Twinmotion', vendor: 'Epic Games', iconUrl: SI('unrealengine', '0E1128'), color: '0E1128' },
    { name: 'Blender', vendor: 'Blender Foundation', iconUrl: SI('blender', 'F5792A'), color: 'F5792A' },
    { name: 'Rhino 3D', vendor: 'McNeel', iconUrl: SI('rhinoceros', '801010'), color: '801010' }
  ],
  'Manufacturing': [
    { name: 'SolidWorks', vendor: 'Dassault', iconUrl: SI('dassaultsystemes', '005386'), color: '005386' },
    { name: 'Inventor', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'PTC Creo', vendor: 'PTC', iconUrl: SI('ptc', '004B8D'), color: '004B8D' },
    { name: 'Siemens NX', vendor: 'Siemens', iconUrl: SI('siemens', '009999'), color: '009999' },
    { name: 'ANSYS', vendor: 'Ansys Inc.', iconUrl: SI('ansys', 'FFB71B'), color: 'FFB71B' },
    { name: 'PDMS', vendor: 'AVEVA', iconUrl: null, color: 'E0271A' },
    { name: 'PDS', vendor: 'Intergraph', iconUrl: null, color: '0033A0' }
  ],
  'Plant & Process': [
    { name: 'AutoCAD Plant 3D', vendor: 'Autodesk', iconUrl: SI('autodesk', '0696D7'), color: '0696D7' },
    { name: 'SmartPlant SP3D', vendor: 'Intergraph', iconUrl: null, color: '0033A0' },
    { name: 'PV Elite', vendor: 'Hexagon', iconUrl: SI('hexagon', '5A2D81'), color: '5A2D81' },
    { name: 'Codeware Compress', vendor: 'Codeware', iconUrl: null, color: 'D43F3A' }
  ],
  'Environmental': [
    { name: 'HEC-HMS', vendor: 'USACE', iconUrl: null, color: '004080' },
    { name: 'HydroCAD', vendor: 'HydroCAD SW', iconUrl: null, color: '00838F' },
    { name: 'StormCAD', vendor: 'Bentley', iconUrl: SI('bentley', '14B5EA'), color: '14B5EA' },
    { name: 'SewerCAD', vendor: 'Bentley', iconUrl: SI('bentley', '14B5EA'), color: '14B5EA' }
  ],
  'Graphics': [
    { name: 'Adobe Photoshop', vendor: 'Adobe', iconUrl: null, color: '31A8FF' },
    { name: 'Adobe Illustrator', vendor: 'Adobe', iconUrl: null, color: 'FF9A00' },
    { name: 'Adobe InDesign', vendor: 'Adobe', iconUrl: null, color: 'FF3366' }
  ]
};

export const leadership = [
  {
    slug: 'santosh-pawar',
    name: 'Santosh Pawar',
    role: 'President & Founder',
    short: 'President & Founder',
    img: 'https://customer-assets.emergentagent.com/job_e504b12e-ed91-44c8-b868-8ff63885d2f4/artifacts/osytvt91_Mr.%20Santosh%20Pawar.png',
    email: 'santy@landdrafters.com',
    linkedin: 'https://www.linkedin.com/in/santoshlpresedent',
    cardBio: 'As the President & Founder of Land Drafters, LLC, Santosh leads land surveying and CAD design services for clients worldwide.',
    quote: 'Building the future, one precise design at a time.',
    bio: [
      'As the President & a founder of Land Drafters, LLC, Santosh Pawar aggressively spearheads land surveying and CAD design services to clients worldwide. He tirelessly guarantees that projects are conducted effectively and efficiently by managing people, clients, and operations in a manner that promotes quality delivery of projects.',
      'Santosh has worked as an engineer and surveyor for over 8 years, where he has been involved in project engineering and surveying, knowledge in topographic surveys, AutoCAD drafting, and civil engineering design.',
      'Working for Land Drafters, LLC, Santosh is inspired by the goal of transforming outsourcing to be more productive, less expensive, and client-oriented. With the knowledge and experience in Civil 3D, surveying, and CAD automation, businesses can have customized solutions to reach client desires.'
    ],
    tagline: 'Driven by precision. Defined by innovation. Dedicated to excellence.',
    education: [
      'Bachelor of Engineering (B.E.) in Civil — Grade A, Delhi University',
      'Diploma in Civil Engineering — Grade A, S.G. University, Kolhapur',
      'Draughtsman in Civil — Government ITI, Kolhapur'
    ],
    expertise: [
      'Land Surveying & Topographic Mapping',
      'CAD Drafting & Civil 3D Expertise',
      'Strategic Project Management',
      'Client Relations & Business Development',
      'Quality Assurance & Process Optimization'
    ]
  },
  {
    slug: 'shrikant-guthe',
    name: 'Shrikant Guthe',
    role: 'Director of Sales & Marketing',
    short: 'Director',
    img: 'https://customer-assets.emergentagent.com/job_e504b12e-ed91-44c8-b868-8ff63885d2f4/artifacts/tnp9rci1_Mr.%20Shriant%20Guthe.png',
    email: 'sg@landdrafters.com',
    linkedin: 'https://www.linkedin.com/in/shrikantguthemarketingmanager/',
    cardBio: 'Director of Sales & Marketing at Land Drafters, Shrikant brings 10+ years of strategic marketing, IT transformation, and international growth experience.',
    quote: 'Engaging, growing, and transforming ideas into excellence with effective marketing concepts.',
    bio: [
      'Being a Director of Sales & Marketing at LAND DRAFTERS (INDIA) PVT. LTD., Shrikant Guthe has tremendous experience strategically planning digital presence and acquiring customers and international markets. As a strategic marketer, he oversees company-wide trends, increased sales productivity, customer lifecycle management, and business growth with superior measurable outcomes.',
      'Shrikant has more than 10 years of experience in marketing, IT transformation, and strategic business growth and has implemented innovative change at organizations such as Marketing Manager at Rely Services, Inc., USA, and leadership roles at Immigreat Global, Gsource Technologies, and DreamWorth Solutions Pvt. Ltd.',
      'From his formative experiences working as an engineer at L&T Automation and Honeywell, he has built technical capabilities to combine marketing and business intelligence. His knowledge in marketing automation, global delivery & customer-centricity solutions has made him a strategic addition to the sales and marketing industry.'
    ],
    tagline: 'Innovating Marketing. Elevating Sales. Driving Business Growth.',
    education: [
      'MBA in Operation Research — Savitribai Phule Pune University',
      "Bachelor's in Mechanical Engineering — Vidya Vardhini's College of Engineering & Technology"
    ],
    expertise: [
      'Digital Marketing & Brand Strategy',
      'Customer Acquisition & Retention',
      'Sales & Revenue Growth',
      'Marketing Automation & Digital Transformation',
      'Global Business Expansion & Market Penetration'
    ]
  }
];

// Operations & Support roster — exactly as published on landdrafters.com/about/team
export const operationsTeam = {
  hra: {
    title: 'HRA, Marketing & Office',
    sub: 'People operations, brand, and administration.',
    members: [
      { name: 'Ms. Rajasi More',   role: 'HRA, Marketing & Office' },
      { name: 'Mr. Mubarak Pathan', role: 'Office' }
    ]
  },
  managers: {
    title: 'Team Managers',
    sub: 'Senior team leads across departments',
    members: [
      { name: 'Mr. Sagar Nimbalkar',   role: 'Team Manager', exp: '10+ Years' },
      { name: 'Mr. Santosh Kamble',    role: 'Team Manager', exp: '5+ Years' },
      { name: 'Mrs. Chhaya Varpe',     role: 'Team Manager', exp: '5+ Years' },
      { name: 'Mr. Abhilesh Wankhede', role: 'Team Manager', exp: '2+ Years' },
      { name: 'Mr. Ganesh Londhe',     role: 'Team Manager', exp: '7+ Years' }
    ]
  },
  seniors: {
    title: 'Senior Engineers',
    sub: 'AutoCAD & Survey CAD Technicians',
    members: [
      { name: 'Mrs. Priyanka Thombare', role: 'Sr. Engineer' },
      { name: 'Mrs. Mamata Lokhande',   role: 'Sr. Engineer' },
      { name: 'Mr. Akash Mane',         role: 'Sr. Engineer' },
      { name: 'Mr. Mukund Dound',       role: 'Sr. Engineer' },
      { name: 'Mr. Azhar Pathan',       role: 'Sr. Engineer' },
      { name: 'Mrs. Prajkta Patil',     role: 'Sr. Engineer' },
      { name: 'Ms. Mansi Pawar',        role: 'Sr. Engineer' },
      { name: 'Ms. Supriya Owhal',      role: 'Sr. Engineer' },
      { name: 'Mrs. Sanyogita Jadhav',  role: 'Sr. Engineer', exp: '3+ Years' }
    ]
  },
  juniors: {
    title: 'Junior Engineers',
    sub: 'AutoCAD & Survey CAD Technicians',
    members: [
      { name: 'Rutuja Magdum',       role: 'Jr. Engineer' },
      { name: 'Sunil Rathod',        role: 'Jr. Engineer' },
      { name: 'Aniket Sutar',        role: 'Jr. Engineer' },
      { name: 'Rushikesh Gaikwad',   role: 'Jr. Engineer' },
      { name: 'Payal Rikame',        role: 'Jr. Engineer' },
      { name: 'Namrata Gaikwad',     role: 'Jr. Engineer' },
      { name: 'Rohan Dhikale',       role: 'Jr. Engineer' },
      { name: 'Shubham Ghadge',      role: 'Jr. Engineer' },
      { name: 'Sampada Rakate',      role: 'Jr. Engineer' },
      { name: 'Vivek Vallakati',     role: 'Jr. Engineer' },
      { name: 'Shritesh Kairamkonda',role: 'Jr. Engineer' },
      { name: 'Dattaprasad Adki',    role: 'Jr. Engineer' },
      { name: 'Alabha Sankpal',      role: 'Jr. Engineer' },
      { name: 'Bhuvan Ganthade',     role: 'Jr. Engineer' },
      { name: 'Sakshi Patil',        role: 'Jr. Engineer' },
      { name: 'Sanika Patil',        role: 'Jr. Engineer' }
    ]
  }
};

export const team = leadership; // legacy alias to keep existing imports working

export const insights = [
  {
    slug: 'engineering-excellence-texas',
    title: 'Delivering Engineering Excellence Across Texas: Infrastructure & Digital Engineering',
    excerpt: 'Explore how advanced engineering, BIM, GIS, Scan-to-BIM, and Digital Twin technologies are supporting infrastructure and land development across Texas.',
    image: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=800&h=500&fit=crop',
    category: 'Engineering Insights',
    date: 'May 28, 2025',
    readTime: '4 min read'
  },
  {
    slug: 'global-engineering-digital',
    title: 'Global Engineering Solutions with Advanced Digital Technologies',
    excerpt: 'Explore how integrated civil engineering, BIM, GIS, Scan-to-BIM, and digital twin technologies are transforming global infrastructure delivery.',
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=500&fit=crop',
    category: 'Digital Engineering',
    date: 'May 22, 2025',
    readTime: '5 min read'
  },
  {
    slug: 'scalable-engineering-us',
    title: 'Delivering Scalable Engineering Solutions Across U.S. Developments',
    excerpt: 'How integrated civil engineering, BIM, Scan-to-BIM, and digital twin technologies are transforming land development and infrastructure delivery.',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=500&fit=crop',
    category: 'Infrastructure Development',
    date: 'May 14, 2025',
    readTime: '3 min read'
  },
  {
    slug: 'bim-future-construction',
    title: 'The Future of Construction: BIM Adoption Across Global Markets',
    excerpt: 'A deep dive into how BIM is reshaping global construction workflows and improving collaboration between stakeholders.',
    image: 'https://images.unsplash.com/photo-1581094289810-adf5d25690e3?w=800&h=500&fit=crop',
    category: 'BIM',
    date: 'April 30, 2025',
    readTime: '6 min read'
  },
  {
    slug: 'survey-grade-accuracy',
    title: 'Survey-Grade Accuracy: Why Sub-Centimeter Precision Matters',
    excerpt: 'Understanding the role of RTK GPS, total stations, and laser scanners in modern land surveying workflows.',
    image: 'https://images.unsplash.com/photo-1628155858736-bacadae33a88?w=800&h=500&fit=crop',
    category: 'Surveying',
    date: 'April 18, 2025',
    readTime: '5 min read'
  },
  {
    slug: 'manufacturing-cad-revolution',
    title: 'Manufacturing CAD Revolution: From 2D to Connected Digital Threads',
    excerpt: 'How modern manufacturing engineering teams are leveraging connected CAD platforms to streamline production.',
    image: 'https://images.unsplash.com/photo-1565514020179-026b92b84bb6?w=800&h=500&fit=crop',
    category: 'Manufacturing',
    date: 'April 02, 2025',
    readTime: '4 min read'
  }
];

export const careers = [
  { title: 'Senior CAD Drafter', location: 'Remote / Pune, India', type: 'Full-time', dept: 'Engineering' },
  { title: 'BIM Coordinator', location: 'Apex, NC', type: 'Full-time', dept: 'BIM Services' },
  { title: 'Civil 3D Designer', location: 'Remote', type: 'Full-time', dept: 'Infrastructure' },
  { title: 'Structural Engineer', location: 'Pune, India', type: 'Full-time', dept: 'Engineering' },
  { title: 'Project Manager - Land Development', location: 'Remote', type: 'Full-time', dept: 'Operations' },
  { title: 'GIS Analyst', location: 'Apex, NC', type: 'Full-time', dept: 'Geospatial' },
  { title: 'Sheet Metal Designer', location: 'Pune, India', type: 'Full-time', dept: 'Manufacturing' },
  { title: 'Junior Drafter (Trainee)', location: 'Pune, India', type: 'Full-time', dept: 'Engineering' }
];

export const coreValues = [
  { title: 'Collaborative', icon: 'Users' },
  { title: 'Curious', icon: 'Search' },
  { title: 'Vibrant', icon: 'Sparkles' },
  { title: 'Willing', icon: 'HandHeart' },
  { title: 'Adaptive', icon: 'Repeat' },
  { title: 'Empathetic', icon: 'Heart' },
  { title: 'Dependable', icon: 'Shield' }
];

export const faqs = [
  { q: 'Where is Land Drafters registered?', a: 'We are registered in the United States, headquartered in Apex, NC with global delivery operations supporting projects worldwide.' },
  { q: 'How soon can you allocate a resource for us?', a: 'Resource allocation typically takes a maximum of two weeks depending on the discipline and skill requirements.' },
  { q: 'How can we track work done by your resources?', a: 'We send Daily Status Reports (DSR) along with detailed timesheets at the end of each month for complete visibility.' },
  { q: 'How do you ensure drawing quality?', a: 'We are a process-driven ISO 9001:2015 certified organization with a proprietary 3-stage quality check process to ensure error-free deliverables.' },
  { q: 'What is your hourly project rate?', a: 'We prefer providing dedicated resources (160 hrs/month) to ensure consistent quality and meet your project needs. Hourly engagements available on request.' },
  { q: 'Do you have US-based representatives?', a: 'Yes, our US headquarters in Apex, NC has representatives who can meet you and your team in person to discuss projects.' },
  { q: 'What software do you work with?', a: 'We work across 50+ industry-standard platforms including AutoCAD, Revit, Civil 3D, Tekla, MicroStation, SolidWorks, ArcGIS and many more.' },
  { q: 'Do you offer rush turnaround?', a: 'Yes — 24-48 hour rush turnaround is available on critical-path drawings and emergency revisions.' }
];
